import CloseIcon from '@mui/icons-material/Close'
import { Dialog, IconButton, useTheme } from '@mui/material'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import useMediaQuery from '@mui/material/useMediaQuery'
import React, { useEffect, useState } from 'react'
import useGlobalLoader from '../../hooks/useGlobalLoader'
import ProductView from '../../Pages/Product/View'
import { getProductUrl } from '../../urls'
import CntLoader from '../Misc/CntLoader'
import Box from '@mui/material/Box'

interface ProductDetailsDialogProps {
  isOpen: boolean

  setIsOpen(
    val: {
      pk: string | number
      slug: string
    } | null
  ): void

  spec: {
    pk: string | number
    slug: string
  } | null
}

const ProductDetailsDialog: React.FC<ProductDetailsDialogProps> = ({ isOpen, setIsOpen, spec }) => {
  const loader = useGlobalLoader()
  const theme = useTheme()
  const lgDown = useMediaQuery(theme.breakpoints.down('lg'))
  const [prevLink, setPrevLink] = useState('')

  useEffect(() => {
    if (isOpen && spec) {
      setPrevLink(location.pathname + location.search)
      window.history.pushState('', '', getProductUrl(spec.slug, spec.pk))
    }
  }, [!!isOpen])

  const handleCloseDialog = () => {
    window.history.pushState('', '', prevLink)
    setIsOpen(null)
  }

  if (!spec) return null

  return (
    <React.Suspense fallback={null}>
      {lgDown && (
        <SwipeableDrawer
          onClose={handleCloseDialog}
          onOpen={() => {
            setIsOpen(spec)
          }}
          disableSwipeToOpen
          disableDiscovery
          swipeAreaWidth={0}
          open={isOpen}
          anchor='bottom'
          ModalProps={{
            keepMounted: false,
          }}
          PaperProps={{
            sx: {
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
              height: '98%',
            },
          }}
          id='product-details-drawer'
        >
          <div className='w-screen max-w-full' style={{ minHeight: 'calc(100vh - 64px)' }}>
            {/* Header */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: '16px',
                py: '20px',
              }}
            >
              <span className='text-capitalize font-bold flex-1 text-center text-base' />
              <span className='absolute right-10 top-10'>
                <IconButton onClick={handleCloseDialog} size='large'>
                  <CloseIcon fontSize='large' />
                </IconButton>
              </span>
            </Box>

            {/* Content */}
            <div className='px-0 md:px-20'>
              {loader.loading && <CntLoader />}
              <ProductView initialId={spec.pk} setIsOpenProductDialog={setIsOpen} isModal />
            </div>
          </div>
        </SwipeableDrawer>
      )}
      {!lgDown && (
        <Dialog
          open={isOpen}
          onClose={handleCloseDialog}
          maxWidth={false}
          scroll='body'
          PaperProps={{ sx: { overflow: 'visible' } }}
        >
          <div
            className='max-w-full'
            style={{
              minHeight: 'calc(100vh - 64px)',
              width: 'calc(100vw - 88px)',
            }}
          >
            <div className='fixed right-[60px] top-40 cursor-pointer z-10 bg-white md:bg-transparent w-auto h-48'>
              <CloseIcon onClick={handleCloseDialog} style={{ fontSize: '36px' }} />
            </div>
            <div className='px-0 py-50 md:px-20 md:py-0'>
              {loader.loading && <CntLoader />}
              <ProductView initialId={spec.pk} setIsOpenProductDialog={setIsOpen} isModal />
            </div>
          </div>
        </Dialog>
      )}
    </React.Suspense>
  )
}

export default ProductDetailsDialog
